module.exports = __webpack_public_path__ + "img/蒙版组-11@2x.02e48b82.webp";